// A7.15 support reply templates (canned responses) — module-local data layer.
// REAL backend (/admin/canned-responses). Agents copy snippets into replies.
import { api } from '@/lib/api'

export interface CannedResponse {
  id: number
  title: string
  category: string
  body: string
  usage_count: number
  updated_at: string
}

export const fetchCanned = (category = '', s?: AbortSignal) =>
  api.get<{ responses: CannedResponse[] }>('/admin/canned-responses', { query: category ? { category } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.responses ?? [])
export const createCanned = (body: { title: string; category: string; body: string }) =>
  api.post<{ id: number }>('/admin/canned-responses', body)
export const updateCanned = (id: number, body: { title: string; category: string; body: string }) =>
  api.put(`/admin/canned-responses/${id}`, body)
export const useCanned = (id: number) => api.post(`/admin/canned-responses/${id}/use`, {})
export const deleteCanned = (id: number) => api.del(`/admin/canned-responses/${id}`)

export const CATEGORIES = ['general', 'billing', 'account', 'abuse', 'technical', 'closing'] as const

export const CN_STR = {
  title: 'Шаблоны ответов',
  desc: 'Готовые ответы для поддержки — категории + счётчик использования. Копируйте в ответ тикета',
  create: 'Новый шаблон',
  name: 'Заголовок',
  category: 'Категория',
  body: 'Текст',
  add: 'Создать',
  save: 'Сохранить',
  edit: 'Изменить',
  copy: 'Копировать',
  copied: 'Скопировано',
  delete: 'Удалить',
  cancel: 'Отмена',
  used: 'использований',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет шаблонов',
  all: 'Все',
} as const
